<template>
  <!-- exhibition-activity .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem to="/exhibition/index/activity/allpro">活动计划</BreadcrumbItem>
          <BreadcrumbItem>添加活动</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="f-tar" style="margin:36px 0;">
        <Button @click="$router.push('/exhibition/index/activity/allpro')">返回</Button>
      </div>
    </div>
    <div class="addpro">
      <div class="addpro-box">
        <Form ref="form" :model="form" :label-width="120" :rules="ruleValidate">
          <FormItem label="活动名称:" prop="name">
            <Input v-model="form.name" placeholder="请输入活动名称" style="width: 400px"></Input>
          </FormItem>
          <FormItem label="活动海报:" prop="proImg">
            <div>
              <upload ref="upload1" :config="uploadBannerConfig" @upload-ok="bannerOK" />
            </div>
          </FormItem>
          <FormItem label="活动视频:" prop="proVideo">
            <div>
              <upload
                :config="uploadVideoConfig"
                @upload-ok="videoOK"
                class="upload-1"
                ref="upload2"
              />
            </div>
          </FormItem>
        <FormItem label="活动类型：" prop="TypeName" clearable>
          <Select v-model="form.TypeName" style="width:400px">
            <Option v-for="item in TypeNameArr" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
          <FormItem label="时间:" prop="date">
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择活动时间"
              style="width: 400px;"
              v-model="applyDate"
            ></DatePicker>
          </FormItem>
          <FormItem label="活动地点类型:" prop="addressType">
            <RadioGroup v-model="form.addressType" @on-change="changeAddressType">
              <Radio label="线上"> 
                <span>线上</span>
              </Radio>
              <Radio label="线下"> 
                <span>线下</span>
              </Radio> 
            </RadioGroup>
          </FormItem>
          <FormItem label="活动地点:" prop="address" v-if="form.addressType === '线下'">
            <Input style="width: 400px" type="text" v-model="form.address" placeholder="可填写展位号、会议室房间号等" />
          </FormItem>
          <FormItem label="活动日程:" prop="Timetable">
            <Input
              v-model="form.Timetable"
              type="textarea"
              :rows="4"
              placeholder="请输入活动日程"
              style="width: 400px"
            ></Input>
          </FormItem>

          <FormItem label="显示顺序:">
            <InputNumber v-model="form.showIndex" :min="0" style="width:100px;margin-right:10px;"></InputNumber>
            <p style="font-size:12px;">(数字越小在您的活动显示列表中显示越靠前)</p>
          </FormItem>

          <FormItem label="活动详情:" class="ivu-form-item-required">
            <div class="no-padding">
              <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal"></customComponentCommon>
            </div>
          </FormItem>
        </Form>
        <div style="width:100%;padding-left:120px;">
          <Button
            type="primary"
            @click="handleSubmit('form',0)"
            style="width:140px;height:35px;font-size:14px"
          >保存</Button>
          <Button
            type="primary"
            @click="handleSubmit('form',1)"
            style="width:140px;height:35px;font-size:14px;margin-left:20px;"
          >保存并预览</Button>
        </div>
      </div>
    </div>
    <Contact />
  </div>
</template>

<script>
let moment = require("moment");
import Contact from "@components/Contact/Contact";
import upload from "@components/upLoad/upLoad";
import { mapGetters, mapActions } from "vuex";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";

export default {
  name: "exhibition-activity-add",
  data() {
    let that = this;
    const validateProImg = (rule, value, callback) => {
      if (that.uploadBanner && that.uploadBanner.length) {
        callback();
      } else {
        // that.$Message.warning("请上传活动图片");
        callback(new Error("请上传活动海报"));
      }
    };
    const proApply = (rule, value, callback) => {
      if (that.applyDate[1]) {
        callback();
      } else {
        callback(new Error("请选择活动时间"));
      }
    };
    return {
      commonType: 2,
      list: null,
      pageSize: 16,
      pageIndex: 1,
      totalCount: 0,
      uploadBanner: [], // 活动图
      uploadVideo: [], // 主图视频
      applyDate: [], // 活动时间

      Introduction: [], // 活动详情
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "(图片要求:2M以下的jpg或png，建议尺寸为900*600px，拖拽上传图片，最多上传15张)",
        limitNum: 15
        // tip: '现场视频可展后上传',
      },
      form: {
        name: "", // 活动名称
        address: "", // 活动地点
        addressType: "线下", // 活动地点
        Timetable: "", // 活动日程
        showIndex: 0, // 显示顺序
        isShow: true, // 是否显示
        TypeName: '', // 显示顺序
      },
      ruleValidate: {
        name: [
          { required: true, message: "活动名称不能为空", trigger: "blur" }
        ],
        proImg: [
          { required: true, validator: validateProImg, trigger: "change" }
        ],
        TypeName: [
          { required: true, message: "活动类型为必填项", trigger: "blur" }
        ],
        address: [
          { required: true, message: "活动地点不能为空", trigger: "blur" }
        ],
        date: [{ required: true, validator: proApply, trigger: "blur" }]
      },
      videoList: [], // 视频详情

      type: [],
      type2: [],
      TypeNameArr: ["新品发布", "签约仪式", "促销活动", "福利派送", "其他"]
    };
  },
  computed: {
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    uploadVideoConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_2";
      config.fileType = "video";
      config.headers = this.formHeaders;
      config.action = this.uploadVideoUrl;
      config.format = ["mp4"];
      config["max-size"] = 51200; // 50M
      config.limitNum = 1;
      config.remind =
        "(视频要求:视频大小不超过50M，建议视频时长9-30秒，视频宽高比16:9)";
      return config;
    },
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo"
    }),
    option() {
      return { compId: this.company.id, pageSize: 1000 };
    }
  },
  created() {},
  methods: {
    ...mapActions({
      addActivity: "activityModuleNew/addActivity",
      getAllvideoMaterial: "materialModule/getAllvideoMaterial",
      transformReqCustomData: "customComponentModule/transformReqCustomData"
    }),
    bannerOK(list) {
      this.uploadBanner = list;
    },
    videoOK(list) {
      this.uploadVideo = list;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async handleSubmit(name,e) {
      let txt = "";
      let valid = await this.validForm(name);
      this.$refs[name].fields.forEach(c => {
        if (txt) return;
        if (c.validateState === "error") {
          txt = c.validateMessage;
        }
      });
      if (!valid && txt) {
        this.$Message.warning(txt);
      }
      if (!valid) return;
      // 主图视频
      let video = {
        cover: 0,
        Time: 200,
        Img: "",
        Link: ""
      };
      if (this.uploadVideo.length > 0) {
        video.Link = this.uploadVideo[0].url;
        video.Img = this.uploadVideo[0].src;
      }
      // 活动详情
      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error("请完善详情信息");
        return;
      }

      let start = moment(this.applyDate[0]).format("YYYY-MM-DD HH:mm:ss");
      let end = moment(this.applyDate[1]).format("YYYY-MM-DD HH:mm:ss");
      let form = {
        ExhibitionId: this.exhibition.id,
        AgentId: this.company.agentId,
        JoinId: this.joinInfo.joinId,
        Name: this.form.name,
        Banner: this.uploadBanner,
        Video: video,
        StartTime: start,
        EndTime: end,
        Timetable: this.form.Timetable,
        Address: this.form.address,
        ShowIndex: this.form.showIndex,
        Introduction: Introduction,
        TypeName: this.form.TypeName,
      };
      let bool = await this.addActivity(form);
      if (bool.successed) {
        this.$Message.success("保存成功");
        if (e === 0) {
          this.$router.push("/exhibition/index/activity/allpro");
        }
        if (e === 1) {
          this.$router.push("/exhibition/index/template");
        }
      } else {
        if (bool.errors && bool.errors[0]) {
          this.$Message.error(bool.errors[0].description);
        } else {
          this.$Message.error("保存失败，请重新尝试");
        }
      }
    },
    changModal($event) {
      this.Introduction = $event;
    },
    changeAddressType(e) {
      if(e === '线上') {
        this.form.address = '线上';
      } else {
        this.form.address = '';
      }
    } 
  },
  components: {
    Contact,
    upload,
    customComponentCommon
  },
  mounted() {}
};
</script>

<style lang="scss">
.addpro {
  .ivu-modal-header {
    border-bottom: none;
    padding: 14px 0;
  }
}
</style>
<style scoped lang="scss">
.ecb {
  .addpro {
    background-color: #fff;
    margin: 30px;
    min-width: 800px;
    &-box {
      padding: 20px 85px 40px 50px;
    }
  }
  .text-box {
    width: 375px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border: dashed 1px rgba(191, 191, 191, 0.5);
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      border: dashed 1px rgba(23, 143, 255, 1);
    }
  }

  .c-1 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
  .c-2 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
  .c-3 {
    &:hover {
      background-color: #f2f2f2;
    }
  }
}
.v-center {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 500;
  }
}
</style>
